import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ECountry } from "../../../shared/oversight-core/enums/country";
import { IUserProfile } from "../../../shared/oversight-core/interfaces/user-profile";
import { RootState } from "../../store";

type UserState = {
  profile?: IUserProfile;
  country: ECountry;
};

const initialState: UserState = {
  profile: undefined,
  country: (localStorage.getItem("country") as ECountry) || "",
};

export const userSlice = createSlice({
  name: "user",
  initialState: { ...initialState },
  reducers: {
    setProfile: (state, action: PayloadAction<IUserProfile>) => {
      state.profile = action.payload;
    },
    resetProfile: (state) => {
      state.profile = undefined;
    },
    setCountry: (state, action: PayloadAction<ECountry>) => {
      state.country = action.payload;
      localStorage.setItem("country", action.payload);
    },
  },
});

export const { setProfile, resetProfile, setCountry } = userSlice.actions;

export const selectProfile = (state: RootState) => state.user.profile;

export const selectCountry = (state: RootState) => state.user.country;

export default userSlice.reducer;
